import * as ActionTypes from './actionTypes';

// src_location_change indicates if the source of the action was a URL Location Change
export const setMapCenter = (lat, lng, src_location_change = false) => {
  return {
    type: ActionTypes.SET_MAP_CENTER,
    map_center: [lat, lng],
    src_location_change
  };
};

// src_location_change indicates if the source of the action was a URL Location Change
export const setMapBoundsAndZoom = (map_bounds, map_zoom, src_location_change = false) => {
  return {
    type: ActionTypes.SET_MAP_BOUNDS_AND_ZOOM,
    map_bounds,
    map_zoom: parseInt(map_zoom, 10),
    src_location_change
  };
};

export const setMapMinZoom = (min_zoom) => {
  return {
    type: ActionTypes.SET_MAP_MIN_ZOOM,
    min_zoom
  };
};

export const setMinimalMapControls = () => {
  return { type: ActionTypes.SET_MAP_MIN_CONTROLS };
};

export const mapRecentred = () => {
  return {
    type: ActionTypes.MAP_RECENTRED
  };
};



// WEBPACK FOOTER //
// ./src/actions/populate_map_details.js